import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const ModalDialog = ({
  size = 'md',
  isOpen,
  onClose,
  title,
  children,
  footer,
  closeOnBackdrop = true,
}) => (
  <Dialog
    open={isOpen}
    onClose={closeOnBackdrop ? onClose : undefined}
    aria-labelledby='modal-dialog-title'
    maxWidth={size}
    fullWidth
  >
    <DialogTitle
      id='modal-dialog-title'
      color='primary'
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
      className='py-2 px-4'
    >
      {title}
      <IconButton aria-label='close' onClick={onClose} edge='end' size='large'>
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent dividers>{children}</DialogContent>
    {footer && <DialogActions>{footer}</DialogActions>}
  </Dialog>
);

export default ModalDialog;
